import { cloneElement, Component, ErrorInfo, ReactElement } from 'react';

import { Logger } from '@mopla/logger';

interface Props {
	errorScreen: ReactElement;
	children: ReactElement;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		const logger = Logger.getInstance('app');
		logger.error('App crash error', error, errorInfo);
	}

	override render() {
		const { children, errorScreen } = this.props;

		return this.state.hasError
			? cloneElement(errorScreen, {
					onCLick: (route: string) => {
						window.location.href = route;
					},
			  })
			: children;
	}
}
